import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import HeadBlock from '@src/components/HeadBlock';

import css from './style.module.scss';
import Breadcrumbs from '../Breadcrumbs';

const ListingPage = (props) => {
	const {
		title,
		description,
		breadcrumbs,
		Suggestions,
		Filters,
		Sorter,
		CardGrid,
		Paging,
		Recent,
		PromoQuestions,
		LinkLines,
	} = props;

	return (
		<>
			{(title || description) && (
				<div className={cn(css.section, css.section_margin_medium)}>
					<HeadBlock
						title={title}
						content={description}
						breadcrumbs={breadcrumbs}
					/>
				</div>
			)}
			{Suggestions && (
				<div className={cn(css.suggestions)}>
					<Suggestions
						mix={css.suggestions}
						sliderWrapMix={css['sliders-wrap-mix']}
						sliderTrackMix={cn(
							css['sliders-track-mix'],
							css['sliders-track-mix_head'],
						)}
					/>
				</div>
			)}
			{Filters && (
				<div className={css.filtersWrap}>
					<Filters
						sliderWrapMix={css['sliders-wrap-mix']}
						sliderTrackMix={cn(
							css['sliders-track-mix'],
							css['sliders-track-mix_head'],
						)}
						wrapperMods={css.filters}
						suggestMod="grey"
					/>
				</div>
			)}
			{Sorter && (
				<div className={css.sorter}>
					<Sorter />
				</div>
			)}
			{CardGrid && <CardGrid />}
			{Paging && (
				<div className={css.pager}>
					<Paging />
				</div>
			)}
			{CardGrid && Recent && <hr className={css.spacer} />}
			{Recent && (
				<Recent
					sliderWrapMix={css['sliders-wrap-mix']}
					sliderTrackMix={css['sliders-track-mix']}
				/>
			)}
			{PromoQuestions && (
				<div className={css.bottomSection}>
					<PromoQuestions state="listing" />
				</div>
			)}
			{LinkLines && (
				<div className={css.bottomSection}>
					<LinkLines />
				</div>
			)}
		</>
	);
};

ListingPage.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	Suggestions: PropTypes.elementType,
	Filters: PropTypes.elementType,
	Sorter: PropTypes.elementType,
	CardGrid: PropTypes.elementType,
	Paging: PropTypes.elementType,
	Recent: PropTypes.elementType,
	PromoQuestions: PropTypes.elementType,
	LinkLines: PropTypes.elementType,
	breadcrumbs: PropTypes.shape(Breadcrumbs.type.propTypes),
};

ListingPage.defaultProps = {
	title: undefined,
	description: undefined,
	Suggestions: undefined,
	Filters: undefined,
	Sorter: undefined,
	CardGrid: undefined,
	Paging: undefined,
	Recent: undefined,
	PromoQuestions: undefined,
	LinkLines: undefined,
	breadcrumbs: undefined,
};

export default ListingPage;
